import Chart from 'chart.js/auto'
import merge from 'deepmerge'

const DEFAULT_LEGEND_COLOR = '#000000'

class ChartBuilder {
  constructor(ctx, type, data, defaultOptions = {}, options = {}) {
    // SET Default For All Charts
    // Colors should map to material design on surface emphasis colors
    Chart.defaults.color = 'rgba(0, 0, 0, 0.6)' // medium emphasis
    Chart.defaults.scale.ticks.color = 'rgba(0, 0, 0, 0.38)' // low emphasis
    Chart.defaults.font.family = 'Roboto'
    Chart.defaults.font.size = 12

    this.chart = new Chart(ctx, {
      type: type,
      data: data,
      options: merge(defaultOptions, options)
    })
  }

  static refresh_data(hook) {
    const newData = JSON.parse(hook.el.dataset.chartData)

    // only do 1-for-1 replacement if old and new datasets have same form
    // otherwise do a wholesale replacement
    // this handles cases where we start with empty datasets
    // and then populate them on update as well as
    // when swapping in selected entirely new data (that is same number of items)
    const existingLabels = hook.chart.data.datasets
      .map((d) => d.label)
      .toString()
    const newLabels = newData.datasets.map((d) => d.label).toString()

    if (
      hook.chart.data.datasets.length === newData.datasets.length &&
      existingLabels === newLabels
    ) {
      hook.chart.data.datasets.forEach((dataset, i) => {
        newData.datasets[i].data.forEach((value, j) => {
          dataset.data[j] = value
        })
      })
    } else {
      hook.chart.data.datasets = newData.datasets
    }

    hook.chart.update()
  }
}

export function generateCircleLegendLabels(chart) {
  return chart.data.datasets.flatMap((dataset, i) => {
    if (dataset.legendSkip) {
      return []
    }

    const color =
      dataset.borderColor || dataset.backgroundColor || DEFAULT_LEGEND_COLOR

    const canvas = document.createElement('canvas')
    canvas.width = 18
    canvas.height = 16
    const ctx = canvas.getContext('2d')

    if (dataset.pointHollow) {
      ctx.strokeStyle = color
      ctx.lineWidth = 2
      ctx.beginPath()
      ctx.arc(8, 8, 6, 0, Math.PI * 2)
      ctx.stroke()
    } else {
      ctx.fillStyle = color
      ctx.beginPath()
      ctx.arc(8, 8, 8, 0, Math.PI * 2)
      ctx.fill()
    }

    return [
      {
        text: dataset.label || '',
        fillStyle: dataset.pointHollow ? 'transparent' : color,
        strokeStyle: color,
        lineWidth: dataset.pointHollow ? 2 : 0,
        pointStyle: canvas,
        hidden: !chart.isDatasetVisible(i),
        datasetIndex: i
      }
    ]
  })
}

export default ChartBuilder
